module.exports = __webpack_public_path__ + "img/new2-2.6840bcdb.jpg";